import React, { Component } from 'react';

import Modal from "../../../src/component/modal/ModalTemplate";
import TextInput from "../input/TextInput";
import RadioBtnList from "../input/RadioBtnList";
import SingleButton from "../button/SingleButton";

import PoiSearchModal from "./PoiSearchModal";

class MessageMapticsModal extends Component {
    constructor(props) {
        super(props);

        this.setValue = this.setValue.bind(this);
        this.setMapticsData = this.setMapticsData.bind(this);
        this.handlePoiSearchModal = this.handlePoiSearchModal.bind(this);

        this.state = {
            address: '',
            sex: '0',
            ageFrom: 19,
            ageTo: 90,
            radius: '', // 50m ~ 2000m
            stayMin: '', // 5분 ~ 30분

            openPoiSearchModal: false,
        }
    }

    setValue(id, value) {
        const { isRemind } = this.props;

        if(isRemind) return;

        switch (id) {
            case 'address':
                this.setState({ address: value });
                break;
            case 'sex':
                this.setState({ sex: value });
                break;
            case 'ageFrom':
                this.setState({ ageFrom: value });
                break;
            case 'ageTo':
                this.setState({ ageTo: value });
                break;
            case 'radius':
                this.setState({ radius: value });
                break;
            case 'stayMin':
                this.setState({ stayMin: value });
                break;
            default:
                break;
        }
    }

    setMapticsData() {
        const { setMapticsData, handleClose, isRemind } = this.props;
        const { address, ageTo, ageFrom, sex, radius, stayMin } = this.state;

        if(isRemind) {
            handleClose();
            return;
        }

        let msg;
        if (! address) {
            msg = "주소가 입력되지 않았습니다.";
        } else if (ageFrom < 19 || ageFrom > 90) {
            msg = "연령은 19세부터 90세까지 입력 가능합니다.";
        } else if (ageTo < 19 || ageTo > 90) {
            msg = "연령은 19세부터 90세까지 입력 가능합니다.";
        } else if (ageFrom > ageTo) {
            msg = "최소 연령이 최대 연령보다 높게 입력 되었습니다.";
        } else if (radius < 50 || radius > 2000) {
            msg = "반경은 최소 50m부터 최대 2,000m까지 설정 가능합니다.";
        } else if (stayMin < 5 || stayMin > 30) {
            msg = "체류 시간은 최소 5분부터 최대 30분까지 설정 가능합니다.";
        }
        if (msg) {
            alert(msg);
            return;
        }

        setMapticsData({
            address: address,
            gender: sex,
            minAge: ageFrom,
            maxAge: ageTo,
            radius: radius,
            stayMin: stayMin,
        });

        handleClose();
    }

    handlePoiSearchModal() {
        const { openPoiSearchModal } = this.state;
        this.setState({ openPoiSearchModal: ! openPoiSearchModal });
    }

    componentDidUpdate(prevProps) {
        const { isRemind, mapticsData } = this.props;

        if (prevProps.isRemind !== isRemind && isRemind) {
            this.setState({
                address: mapticsData.address,
                sex: String(mapticsData.gender),
                ageFrom: mapticsData.minAge,
                ageTo: mapticsData.maxAge,
                radius: mapticsData.radius,
                stayMin: mapticsData.stayMin,
            });
            return;
        }

        if (prevProps.mapticsData !== mapticsData) {
            this.setState({
                address: mapticsData.address,
                sex: String(mapticsData.gender),
                ageFrom: mapticsData.minAge,
                ageTo: mapticsData.maxAge,
                radius: mapticsData.radius,
                stayMin: mapticsData.stayMin,
            });
        }

        if (prevProps.isRemind !== isRemind && !isRemind) {
            this.setState({
                address: '',
                sex: '0',
                ageFrom: 19,
                ageTo: 90,
                radius: '',
                stayMin: '',
            });
        }
    }


    render() {
        const { isOpen, handleClose, isRemind } = this.props;

        const { setValue, setMapticsData } = this;
        const { address, sex, ageFrom, ageTo, radius, stayMin } = this.state;

        const { openPoiSearchModal } = this.state;
        const { handlePoiSearchModal } = this;

        return (
            <>
                <Modal
                    open={isOpen}
                    handleClose={handleClose}
                    className="react-full-modal"
                    modalTitle="지오펜스 그리기"
                    overlayClassName="modal-overlay"
                >
                    <div className='modal-body'>
                        <ul className="mb-4 p-0">
                            <li className="p-0 text-light-gray h6">- 지오펜스는 메시지 발송을 위해 타겟을 추출하고자 하는 원형의 범위를 나타냅니다.</li>
                            <li className="p-0 mb-0 text-light-gray h6">- 기준 주소는 도로명 주소를 활용하여 입력해 주셔야 합니다.</li>
                        </ul>
                        <div className="modal-container">
                            <div className="col-lg-6 col-md-12">
                                <div className="mb-4">
                                    <h4 className="mb-1">주소</h4>
                                    <div className="d-flex gap-2">
                                        { ! isRemind &&
                                            <SingleButton
                                                className="btn btn-sm btn-primary white-space-nowrap"
                                                label="주소 검색"
                                                handleClick={handlePoiSearchModal}
                                            />
                                        }
                                        <TextInput
                                            className='form-control'
                                            type="text"
                                            id="address"
                                            placeholder="도로명 주소 기준으로 입력해 주세요."
                                            value={address}
                                            onChange={setValue}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                                <div className="mb-4">
                                    <h4 className="mb-1">성별</h4>
                                    <RadioBtnList
                                        id="sex"
                                        list={[
                                            { label: '전체', value: '0' },
                                            { label: '남성', value: '1' },
                                            { label: '여성', value: '2' },
                                        ]}
                                        value={sex}
                                        onChange={setValue}
                                    />
                                </div>
                                <div className="mb-4">
                                    <div className="d-flex align-items-baseline mb-1">
                                        <h4 className="mb-0">연령</h4>
                                        <p className="mb-0 ms-2 text-light-gray">연령은 19세부터 90세까지 입력 가능합니다.</p>
                                    </div>
                                    <TextInput
                                        className='form-control-sm me-2'
                                        type="number"
                                        id="ageFrom"
                                        value={ageFrom}
                                        onChange={setValue}
                                        warning={ageFrom && ageFrom < 19}
                                    />
                                    <span>~</span>
                                    <TextInput
                                        className='form-control-sm ms-2'
                                        type="number"
                                        id="ageTo"
                                        value={ageTo}
                                        onChange={setValue}
                                        warning={ageTo && ageTo > 90}
                                    />
                                </div>
                                <div className="mb-4">
                                    <div className="d-flex align-items-baseline mb-1">
                                        <h4 className="mb-0">반경</h4>
                                        <p className="mb-0 ms-2 text-light-gray">반경은 최소 50m부터 최대 2,000m까지 설정 가능합니다.</p>
                                    </div>
                                    <TextInput
                                        className='form-control-sm me-2'
                                        type="number"
                                        id="radius"
                                        value={radius}
                                        onChange={setValue}
                                        warning={radius && (radius < 50 || radius > 2000)}
                                    />
                                    <span>m</span>
                                </div>
                                <div className="mb-0">
                                    <div className="d-flex align-items-baseline mb-1">
                                        <h4 className="mb-0">체류시간</h4>
                                        <p className="mb-0 ms-2 text-light-gray">체류시간은 최소 5분부터 최대 30분까지 설정 가능합니다.</p>
                                    </div>
                                    <TextInput
                                        className='form-control-sm me-2'
                                        type="number"
                                        id="stayMin"
                                        value={stayMin}
                                        onChange={setValue}
                                        warning={stayMin && (stayMin < 5 || stayMin > 30)}
                                    />
                                    <span>분</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='modal-footer'>
                        <div className="d-flex flex-row justify-content-between w-100">
                            <span>* 추출된 모수가 너무 적을 경우 목표 발송건수보다 적게 발송될 수 있습니다. (적게 발송된 건수는 포인트로 환급됩니다.)</span>
                            <div>
                                <SingleButton
                                    className="btn btn-primary btn-md"
                                    label={isRemind ? "확인" : "타겟 설정"}
                                    handleClick={setMapticsData}
                                />
                            </div>
                        </div>
                    </div>
                    <PoiSearchModal
                        isOpen={openPoiSearchModal}
                        handleClose={handlePoiSearchModal}
                        setAddress={setValue}
                    />
                </Modal>
            </>
        )
    }
}

MessageMapticsModal.defaultProps = {
    isOpen: false,
    handleClose: function() {},
}

export default MessageMapticsModal;
